export default {
  game: {
    title: "MapleStory R- Evolution 单手杀挑战",
    description:
      "由NEXON授权的手機RPG《MapleStory R- Evolution 》現正開放事前登錄！預約即可獲得限定时装、SSR寵物等豪華特典！",
    keywords:
      "MapleStory, MapleStory R, MapleStory M, MapleStory: Idle RPG, NEXON, characters, adventure, idle, skills, Zakum, orange mushroom, mushroom, pink bean, yeti, green snail, slime, ludibrium, henessys, card game, team battle, team fight, boss fight, RPG, Idle RPG, Dragon, game, mobile game, Sword, Upgrade, Class, Warrior, Mage, Archer, Swordsman, Bowman, Thief, Cannoneer, magician, brave, magic, battle, 2D game, PVP, PVE, SAO, MMORPG, Action RPG, ARPG, JRPG, SSR pets, Download, Pre-register, reward Legend of Mushroom, Legend of Zelda, Legend of Slime, Nobody's Adventure, Guardian Tales, LaTale, LaTale M, Sky Utopia, MeowHeroes, MapleHeroes, RO, Ragnarok",
    description2:
      "歡迎來到由NEXON授权的RPG《枫之谷R》！现在下载即可獲得限定时装、SSR寵物等豪華特典！",
    keywords2:
      "MapleStory, MapleStory R, MapleStory M, MapleStory: Idle RPG, NEXON, characters, adventure, idle, skills, Zakum, orange mushroom, mushroom, pink bean, yeti, green snail, slime, ludibrium, henessys, card game, team battle, team fight, boss fight, RPG, Idle RPG, Dragon, game, mobile game, Sword, Upgrade, Class, Warrior, Mage, Archer, Swordsman, Bowman, Thief, Cannoneer, magician, brave, magic, battle, 2D game, PVP, PVE, SAO, MMORPG, Action RPG, ARPG, JRPG, SSR pets, Download, Pre-register, reward Legend of Mushroom, Legend of Zelda, Legend of Slime, Nobody's Adventure, Guardian Tales, LaTale, LaTale M, Sky Utopia, MeowHeroes, MapleHeroes, RO, Ragnarok",
    language_1: "小怪击杀\n奖励条件",
    language_2: "扎昆击杀\n奖励条件",
    language_3: "已达成",
    language_4: "未达成",
    language_5: "领取",
    language_6: "复制",
    language_7: "活动已结束，仅可领取虚宝序号",
    language_8: "复制兑换码，在游戏中获取奖励！",
    language_9: "完成任务即可获得奖励序号",
    language_10: "商店下载送",
    language_11: "商店预约送",
    language_12: "限定扎昆时装",
    language_13: "立即下载",
    language_14: "立即预约",
    // language_15: "下载",
    // language_16: "预订",
    // language_17: "去商店下载",
    // language_18: "去商店预注册",
    // language_19: "关注我们",
    language_20: "立即预约",
    language_21: "点击领取序号",
    language_22: "复制成功",
    language_23: "复制失败，请尝试手动复制",
    language_24: "游戏\n规则",
    confirmDialog: {
      language_1: "已击杀",
      language_2: "只小怪",
      language_3: "可领取",
      language_4: "（最高20）",
      language_5: "每人仅可领取一次奖励，是否确认领取？",
      language_6: "领取",
      language_7: "取消",
    },
    endDialog: {
      language_1: "活动已结束",
    },
    registerDialog: {
      language_1: "请先完成邮箱预约",
      language_2: "以参与活动并获得",
      language_3: "SSR宠物",
      language_4: "请输入邮箱",
      language_5: "同意",
      language_6: "服务条款",
      language_7: "及",
      language_8: "隐私政策",
      //   language_9: "立即预约",
      language_10: "SSR",
      language_11: "-幼红独角狮",
      language_12: "请先同意服务条款及隐私政策",
    },
    taskDialog: {
      language_1: "",
      language_2: "只小怪击杀",
      language_3: "BOSS",
      language_4: "-扎昆击杀",
    },
  },
  treasure: {
    passInput: "请输入密码",
    queryReward: "奖励查询",
    rules: "规则",
    emailInput: "请输入邮箱",
    copySuccess: "复制成功",
    copyFail: "复制失败，请手动复制",
    emptyPass: "口令不能为空",
  },
  reserve: {
    pleaseEnter: "Insira um e-mail válido",
    pleaseAgree: "Marque a caixa para concordar com os termos",
    emailPlaceholder: "Insira um e-mail válido",
    successShip: "船票序号:",
    // 邀请文本
    invitedText: "已邀请人数:",
    inviteLinkText: "邀请链接:",
    copyLinkText: "复制链接",
    copyLinkSuccess: "复制链接成功",
    shareToText: "分享到：",
    // 导航文本
    nav1: "事前预约",
    nav2: "单手杀挑战",
    nav3: "职业",
    nav4: "玩法介绍",
    nav5: "开始游戏",
    // 预约错误提示
    emailEmpty: "Insira um e-mail válido",
    emailInvalid: "Formato de e-mail inválido. Verifique e tente novamente.",
    agreeTerms: "Marque a caixa para concordar com os termos",
    agreementText: "Concordo",
    termsText: "Termos de Serviço",
    andText: "e",
    privacyText: "Política de Privacidade",
    // 预约人数文本
    totalNumberText:
      "aventureiros já resgataram as recompensas de pré-registro!",
    successfulResText: "Pré-registro concluído!",
    successfulResText2: "Bem-vindo de volta!",
  },
  foot: {
    agree: "concordo",
    and: "e",
    termsOfService: "Termos de Uso",
    privacyPolicy: "Política de Privacidade",
    Notice: "Avisos",
    EmailText: "GM Email：",
    info: "© NEXON Korea Corp.All Rights Reserved",
    info1: "",
    info2: "",
    info3: "",
    info4: "",
    rotwilightsea:
      "© Gravity Co., LTD & Lee MyoungJin(studio DTDS). All Rights Reserved.",
    tkingdomssea:
      "Copyright© 2025 RASTAR GAMES (HK) CO., Ltd. All Rights Reserved",
    rotwilightglobal:
      "© Gravity Co., Ltd. & Lee MyoungJin(studio DTDS). Todos os direitos reservados.",
  },
  news: {
    NextPage: "Página anterior",
    PrevPage: "Próxima página",
    NextContent: "Post anterior",
    PrevContent: "Próximo post",
    Return: "Voltar para lista",
    ReturnList: "Back to List",
    More: "Mais",
    None: "gone",
  },
};
